import "./assets/main.css";

import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";
import { useTheme } from "@/stores/theme.ts";

const app = createApp(App);

app.use(createPinia());

useTheme();

app.use(router);

app.mount("#app");
